var exports = {
  "kL": "DiscoveryCompanionRecordsPage.module__container___MkNxWH",
  "wx": "DiscoveryCompanionRecordsPage.module__header___MkNxWH",
  "VW": "DiscoveryCompanionRecordsPage.module__headerContent___MkNxWH",
  "nr": "DiscoveryCompanionRecordsPage.module__headerIcon___MkNxWH",
  "DD": "DiscoveryCompanionRecordsPage.module__title___MkNxWH",
  "XG": "DiscoveryCompanionRecordsPage.module__scroller___MkNxWH",
  "Qs": "DiscoveryCompanionRecordsPage.module__content___MkNxWH",
  "gK": "DiscoveryCompanionRecordsPage.module__historySection___MkNxWH",
  "Lv": "DiscoveryCompanionRecordsPage.module__intro___MkNxWH",
  "Xz": "DiscoveryCompanionRecordsPage.module__introTitle___MkNxWH",
  "Lx": "DiscoveryCompanionRecordsPage.module__introDescription___MkNxWH",
};

module.exports = exports;
